module.exports = __webpack_public_path__ + "static/media/MIAB9807-180730-115_Small.0683ad1f.jpg";